import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import SideBarItemList from './SideBarItemList';
import SolarToolboxLinear from '../icons/SolarToolboxLinear';
import SolarDatabaseLinear from '../icons/SolarDatabaseLinear';
import SolarHammerLinear from '../icons/SolarHammerLinear';
import { useAuth } from 'context/AuthContext';
import { canViewToolsBase } from 'utils/helpers/access/hasUserAccess';

const SideBarTools = () => {
    const { t } = useTranslation();
    const { auth } = useAuth();
    const location = useLocation();
    const showToolsBase = canViewToolsBase(auth?.user);

    if (showToolsBase) {
        return (
            <SideBarItemList
                title={t('SideBarUl.itemTools')}
                icon={<SolarToolboxLinear />}
                iconClass="pc-micon--tools"
                itemsList={[
                    {
                        label: t('SideBarUl.itemToolsBase'),
                        to: '/tools',
                        icon: <SolarDatabaseLinear />,
                    },
                    {
                        label: t('SideBarUl.itemToolsMy'),
                        to: '/tools/my',
                        icon: <SolarHammerLinear />,
                    },
                ]}
            />
        );
    }

    return (
        <li className={`pc-item ${location.pathname.startsWith('/tools') ? 'active' : ''}`}>
            <Link className="pc-link hide-sidebar" to="/tools/my">
                <span className="pc-micon pc-micon--tools">
                    <SolarHammerLinear />
                </span>
                <span className="pc-mtext">{t('SideBarUl.itemToolsMy')}</span>
            </Link>
        </li>
    );
};

export default SideBarTools;
